export enum PermissionsEnum {
  MANAGER_PRODUCTS_SELLERS = 'product-managerProductsBySellers',
  PRODUCTS_LIST = 'product-list',
  PRODUCTS_SHOW = 'product-show',
  PRODUCTS_EDIT = 'product-edit',
  PRODUCTS_DELETE = 'product-delete',
}
